// extracted by mini-css-extract-plugin
export default {"langSelect":"langSelect__F3uoFG","langSelectPopup":"langSelectPopup__D3XhC3","langSelectOption":"langSelectOption__MHlOXu"};